import React from 'react'
import { Image, View, Text } from '@react-pdf/renderer'

const Header = () => {

    return (
        <View
            style={{
                marginTop: "20px",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                padding: "5px 0",
            }}
        >
            <Image
                src="/images/ruler-black.png"
                style={{
                    width: "15px",
                    marginRight: "5px"
                }}
            />
            <Text
                style={{
                    textAlign: "center",
                    fontSize: "12px"
                }}
            >
                MEASURES CHECK
            </Text>


        </View>
    )
}

export default Header